<template>
    <div>
        <az-call-to-action dark
                           :active="licitacao.podePublicar"
                           :outline="!licitacao.podePublicar"
                           @click="confirmarPublicacao">
            Publicar
        </az-call-to-action>
        <az-confirm @onConfirm="efetuarPublicacao" @onDecline="esconderDialog"
                    v-if="mostrarDialog" :maxWidth=320>
            Deseja realmente efetuar a publicação?
        </az-confirm>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {actionTypes} from '@/commons/constants'
import validarDadosGerais
  from "@/views/credenciamento/detalhe-credenciamento/orgao/credenciamento-atualizacao-validar-dados-gerais";

export default {
        name: 'LicitacaoAtualizacaoAcoesPublicar',
        data() {
            return {
                globalLoadingAtivado: false,
                mostrarDialog: false
            }
        },
        computed: {
            ...mapState(['licitacao', 'loki'])
        },
        methods: {
            async confirmarPublicacao() {

              const validado = await this.$validator._base.validateAll()
              if (!validado) {
                this.mostrarNotificacaoErro('Preencha corretamente os campos obrigatórios.')
                return
              }
              const amparoValido = validarDadosGerais.validarAmparoLegal(this.licitacao)
              if (!amparoValido) {
                this.mostrarNotificacaoErro('Preencha e salve os Dados do Credenciamento.')
                return
              }
              const isDataAberturaEhAnteriorADataFimPropostaValida = validarDadosGerais.validarPeriodoDataAberturaEDataFimProposta(this.licitacao)
              if (!isDataAberturaEhAnteriorADataFimPropostaValida.valido) {
                this.mostrarNotificacaoErro(isDataAberturaEhAnteriorADataFimPropostaValida.mensagem)
                return
              }

              this.mostrarDialog = true
            },

            desabilitarLoading() {
                if (!this.globalLoadingAtivado) {
                    this.desabilitarLoadingGlobal()
                }
            },
            async efetuarPublicacao() {
                this.esconderDialog()
                this.habilitarLoading()
                try {
                    await this.publicar()
                    await this.buscarLicitacao(this.licitacao.id)
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoading()
                } catch (e) {
                    this.desabilitarLoading()
                }
            },
            esconderDialog() {
                this.mostrarDialog = false
            },
            habilitarLoading() {
                this.globalLoadingAtivado = this.loki.isGlobalLoadingEnabled
                this.habilitarLoadingGlobal()
            },
            async publicar() {
                this.setMensagemLoading('Publicando...')
                await this.publicarLicitacao(this.licitacao.id)
            },
            ...mapActions([actionTypes.PUBLICAR_LICITACAO, actionTypes.BUSCAR_LICITACAO])
        }
    }
</script>